import React from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction, userActions } from "../../_actions";
import { AppTable } from "../../_components/AppTable";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import { validation } from "../../_helpers/passwordPolicy";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
} from "antd";
import axios from "axios";
import { UserForm } from "../HomePage/UserForm";
import { ProfileForm } from "./ProfileForm";
import { DistrictOrder } from "./districtsOrder";
const { Option } = Select;

class Profile extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    isCreateUserDrawerVisible: false,
    isUpdate: false,
    userFormEditData: [],
    resetFrom: false,
    userList: [],
    district_map: false,
  };
  userForm = React.createRef();
  componentDidUpdate() {}

  componentDidMount() {}

  onFormUpdate = (values) => {
    const { user } = this.props;
    if (values.password) {
      let validatPasswordPoliy = validation.cmisCheckPasswordPolicy(
        values.password,
        values.name,
        "",
        "",
        "",
        "",
        "",
        ["cmis"],
      );

      if (!validatPasswordPoliy[0]) {
        message.error(validatPasswordPoliy[1]);
        return false;
      }

      const hashedPassword = base64_encode(values.password);
      let userUpdateObj = {
        ...values,
        password: values.password ? hashedPassword : null,
        confirm: values.password ? hashedPassword : null,
      };
      this.props.dispatch(userActions.updateUser(userUpdateObj, user.id));
      message.success("Profile Update Successfully!!");
      message.success("System will be logged off now !!!");
      setTimeout(() => {
        this.props.dispatch(userActions.logout());
      }, 2000);
    } else {
      let userUpdateObj = {
        ...values,
      };
      this.props.dispatch(userActions.updateUser(userUpdateObj, user.id));
      message.success("Profile Update Successfully!!");
      message.success("System will be logged off now !!!");
      setTimeout(() => {
        this.props.dispatch(userActions.logout());
      }, 2000);
    }
  };
  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  onCloseDrawer = () => {
    this.setState({
      district_map: false,
    });
  };
  render() {
    const { user, users } = this.props;
    const roleFour = user && user.role === "4" ? "घटक" : "जिल्हा";

    const { pc_cities, basicDistricts } = this.props;
    return (
      <div className="row">
        <div className="col-md-6 col-md-offset-3">
          <div className="site-page-header-ghost-wrapper">
            <PageHeader
              ghost={false}
              onBack={false}
              title={user && user.userid}
              subTitle={
                user && user.role === "4" ? "( ADMIN )" : "( SUPER ADMIN )"
              }
              extra={
                <>
                  {this.props.user.role === "4" && (
                    <div className="col-md-4 col-md-offset-3">
                      <Button
                        type="primary"
                        onClick={() => {
                          this.setState({
                            district_map: true,
                          });
                        }}
                      >
                        District Order
                      </Button>
                    </div>
                  )}
                </>
              }
            >
              <Descriptions size="small" column={3}>
                <Descriptions.Item
                  label={user && user.role === "8" ? "राज्य" : roleFour}
                >
                  {user && user.role === "8"
                    ? "महाराष्ट्र"
                    : "महाराष्ट्र" +
                      " " +
                      "( " +
                      this.getCityName(user && user.cityId) +
                      " )"}
                </Descriptions.Item>
                <Descriptions.Item label=""></Descriptions.Item>
              </Descriptions>
            </PageHeader>
          </div>
        </div>

        <Divider />
        <ProfileForm
          ref={this.userForm}
          user={user}
          cityData={pc_cities}
          isUpdate={this.state.isUpdate}
          districtData={basicDistricts}
          users={users}
          onFormFinish={this.onFormFinish}
          onFormUpdate={this.onFormUpdate}
          userFormEditData={user}
          resetFrom={this.state.resetFrom}
        ></ProfileForm>
        <Drawer
          title="Police Station List "
          width={900}
          maskClosable={false}
          closable={false}
          onClose={this.onCloseDrawer}
          visible={this.state.district_map}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <div
                className="steps-action"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <Button
                    onClick={this.onCloseDrawer}
                    style={{ marginRight: 8 }}
                  >Cancel</Button>
                </div>
              </div>
            </div>
          }
        >
          <DistrictOrder />
        </Drawer>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  const { newsList, pc_cities, basicDistricts } = professionals;
  return {
    user,
    users,
    professionals,
    pc_cities,
    basicDistricts,
  };
}

const connectedProfile = connect(mapStateToProps)(Profile);
export { connectedProfile as Profile };
